export default __webpack_public_path__ + "static/media/avatar_131.7064bf87.png";